<fieldset>
  <legend class="d-none">{{ attribute.label }}</legend>
  <div [id]="createAttributeIdForConfigurator(attribute)">
    <div *ngIf="withQuantityOnAttributeLevel" class="cx-attribute-level-quantity-price">
      <cx-configurator-attribute-quantity
        (changeQuantity)="onChangeQuantity($event)"
        [quantityOptions]="
          extractQuantityParameters(attribute.quantity, !attribute.required)
        "></cx-configurator-attribute-quantity>
      <cx-configurator-price [formula]="extractPriceFormulaParameters()"></cx-configurator-price>
    </div>
    <ng-container *ngFor="let value of attribute.values; let i = index">
      <udex-tile
        class="d-block"
        [class.udex-mt-12]="i > 0"
        [interactive]="(stepInputService.isStepInputDisabled$ | async) === null"
        (click)="onAttributeChange(i); udexEventTypeService.preventEventDefault($event)">
        <div class="tile">
          <udex-checkbox
            [id]="createAttributeValueIdForConfigurator(attribute, attribute?.values?.[0]?.valueCode ?? '')"
            [checked]="value.selected"
            [cxFocus]="{key: attribute?.name + '-' + attribute?.values?.[0]?.name}"
            (change)="onAttributeChange(i)"
            (click)="$event.stopPropagation(); $event.stopImmediatePropagation(); $event.preventDefault()"
            [name]="createAttributeIdForConfigurator(attribute)"
            [accessibleName]="createAttributeIdForConfigurator(attribute)"
            [disabled]="stepInputService.isStepInputDisabled$ | async"></udex-checkbox>
          <div class="d-flex tile__content flex-column udex-pt-8 udex-mt-2">
            <label
              [id]="createValueUiKey('label', attribute.name, value.valueCode)"
              [for]="createAttributeValueIdForConfigurator(attribute, value.valueCode)"
              class="tile__content__heading body--s"
              >{{ (withLongTextUsedForDisplay ? value.description : value.valueDisplay) || value.valueDisplay }}
            </label>
            <label
              *ngIf="!withLongTextUsedForDisplay && value.description"
              class="tile__content__description udex-pt-4 body--xs"
              [innerHTML]="value.description || value.valueDisplay"></label>
          </div>
          <div class="cx-value-price">
            <cx-configurator-price [formula]="extractValuePriceFormulaParameters(value)"></cx-configurator-price>
          </div>
        </div>
        <cx-configurator-attribute-quantity
          class="udex-mt-8"
          *ngIf="value.selected && withQuantity && !withQuantityOnAttributeLevel"
          (changeQuantity)="onChangeValueQuantity($event, value.valueCode, i)"
          [quantityOptions]="
            extractQuantityParameters(value.quantity, allowZeroValueQuantity)
          "></cx-configurator-attribute-quantity>
      </udex-tile>
    </ng-container>
  </div>
</fieldset>
